const getNodeWidth = (node: Element | null): number => {
  if (!node) return 0;
  const widthStr: string = window
    .getComputedStyle(node, null)
    .getPropertyValue('width');
  const width = Number.parseFloat(widthStr);
  return Number.isNaN(width) ? 0 : width;
};

const calcMax = (
  containerNode: HTMLElement | null,
  // moreBtnNode: HTMLElement | null,
  moreBtnWidth: number = 0,
  itemWidth: number,
  itemSpacing: number,
) => {
  if (!containerNode) return 0;
  const containerWidth = getNodeWidth(containerNode);
  // const moreBtnWidth = getNodeWidth(moreBtnNode);
  const remainsWidth = containerWidth - moreBtnWidth - 10;
  return Math.floor(remainsWidth / (itemWidth + itemSpacing));
};

export { calcMax };
